var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { stringify } from 'query-string';
const basePath = '/api-management/1.0/api-plans';
const internalBasePath = '/api-management/internal/api-plans';
const SearchFields = ['name', 'description'];
export const apiPlansDataProvider = context => {
    return {
        async getList({ filter, pagination, sort }) {
            const url = `${context.apiUrl}${basePath}?${stringify(Object.assign(Object.assign({}, getFilter(filter)), { page: pagination.page - 1, size: pagination.perPage, sort: `${sort.field},${sort.order}` }))}`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include',
            });
            return {
                data: json.results.map((_a) => {
                    var { uuid } = _a, item = __rest(_a, ["uuid"]);
                    return (Object.assign(Object.assign({}, item), { id: uuid }));
                }) || [],
                total: json.totalElements || 0,
            };
        },
        async getMany({ ids }) {
            const apiPlans = await Promise.all(ids.map(id => this.getOne({ id })));
            return {
                data: apiPlans.reduce((acc, getOneResult) => {
                    acc.push(getOneResult.data);
                    return acc;
                }, []),
            };
        },
        async getOne({ id }) {
            const url = `${context.apiUrl}${basePath}/${id}`;
            const _a = (await context.fetchJson(url, { credentials: 'include' })).json, { uuid } = _a, data = __rest(_a, ["uuid"]);
            return {
                data: Object.assign(Object.assign({}, data), { id: uuid }),
            };
        },
        async getApisByApiPlan({ apiPlanId }) {
            // Filter by API Plan
            const { json: apiPlanApisIds } = await context.fetchJson(`${context.apiUrl}${basePath}/${apiPlanId}/apis`, {
                credentials: 'include',
            });
            const apis = await Promise.all(apiPlanApisIds.map(({ uuid }) => {
                // Get APIs One By One
                return context
                    .fetchJson(`${context.apiUrl}/api-management/1.0/apis/${uuid}`, {
                    credentials: 'include',
                })
                    .then(({ data }) => data);
            }));
            return {
                data: apis,
                total: apis.length,
            };
        },
        async getApiPlansByApi({ orgUuid, apiId }) {
            const params = { apiUuid: apiId };
            if (orgUuid) {
                params.orgUuid = orgUuid;
            }
            const url = `${context.apiUrl}${internalBasePath}?${stringify(params)}`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include'
            });
            return {
                data: json,
                total: json.length,
            };
        },
        async getApiPlansFeatureFlag() {
            const url = `${context.apiUrl}/Settings('FEATURE_FLAG_API_PLANS')`;
            const data = __rest((await context.fetchJson(url, {
                credentials: 'include',
            })).json, []);
            return { data: { value: data.Value } };
        },
    };
};
export const getFilter = (_a, searchFields = SearchFields) => {
    var { q } = _a, filters = __rest(_a, ["q"]);
    let result = filters;
    if (!q) {
        return filters;
    }
    // The API does not support the `q` field for fulltext search.
    // Instead, we must add a filter for each searchable field supported by this resource
    if (!searchFields || searchFields.length === 0) {
        return result;
    }
    return searchFields.reduce((acc, field) => {
        acc[field] = q;
        return acc;
    }, Object.assign({}, filters));
};
//# sourceMappingURL=apiPlans.js.map